import ComponentModule from "@eisinc/Overrides/Components/TwoButtonModal";

export * from "@eisinc/Overrides/Components/TwoButtonModal";

export default ComponentModule;
